(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // scripts/base.ts
  document.addEventListener("DOMContentLoaded", () => {
    const ua = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const maxTouchPoints = navigator.maxTouchPoints || 0;
    const isIOS = /iPad|iPhone|iPod/.test(ua) || platform === "MacIntel" && maxTouchPoints > 1;
    if (!isIOS) return;
    document.documentElement.classList.add("is-ios");
    document.body.classList.add("is-ios");
  });

  // scripts/settings/animation.ts
  var animGetTime = (s) => {
    if (s.endsWith("ms")) {
      return parseFloat(s);
    } else if (s.endsWith("s")) {
      return parseFloat(s) * 1e3;
    }
    return 200;
  };
  var ANIMATION_SETTINGS = {
    // Easing functions
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    easeOut: "cubic-bezier(0, 0, 0.2, 1)",
    // Timing strings
    timeDefault: "300ms",
    med: "300ms",
    short: "150ms",
    slow: "500ms",
    // Millisecond durations
    get durationDefault() {
      return animGetTime(this.timeDefault);
    },
    get durationMedium() {
      return animGetTime(this.med);
    },
    get durationShort() {
      return animGetTime(this.short);
    },
    get durationSlow() {
      return animGetTime(this.slow);
    }
  };

  // scripts/tools/form-validation.ts
  (() => {
    if (window.location.search.includes("contact_posted=true")) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    const TOUCH_EVENTS = ["blur"];
    const touched = /* @__PURE__ */ new WeakSet();
    function isSubmittable(el) {
      if (!el || !("tagName" in el) || !(el.tagName === "INPUT" || el.tagName === "SELECT" || el.tagName === "TEXTAREA")) {
        return false;
      }
      const input = el;
      if (!input.required) return false;
      if (input instanceof HTMLInputElement && input.type === "hidden" || input instanceof HTMLElement && input.offsetParent === null) {
        return false;
      }
      return true;
    }
    const closestForm = (el) => {
      var _a;
      return el && el.form || ((_a = el == null ? void 0 : el.closest) == null ? void 0 : _a.call(el, "form")) || null;
    };
    const setFieldState = (field, isValid) => {
      field.classList.remove("is-valid", "is-error");
      field.classList.add(isValid ? "is-valid" : "is-error");
      field.setAttribute("aria-invalid", isValid ? "false" : "true");
      const p = field.parentElement;
      if (p) {
        p.classList.remove("is-valid", "is-error");
        p.classList.add(isValid ? "is-valid" : "is-error");
        p.querySelectorAll(".o-form__error").forEach((el) => el.remove());
        if (!isValid) {
          const errorDiv = document.createElement("div");
          errorDiv.className = "o-form__error";
          if (field instanceof HTMLInputElement) {
            if (field.type === "email") {
              errorDiv.textContent = "Please enter a valid email address.";
            } else if (field.type === "url") {
              errorDiv.textContent = "Please enter a valid URL.";
            } else if (field.type === "number") {
              errorDiv.textContent = "Please enter a valid number.";
            } else if (field.type === "checkbox") {
              errorDiv.textContent = "This checkbox is required.";
            } else if (field.type === "radio") {
              errorDiv.textContent = "Please select an option.";
            } else if (field.type === "file") {
              errorDiv.textContent = "Please select a valid file.";
            } else if (field.required) {
              errorDiv.textContent = "This field is required.";
            } else {
              errorDiv.textContent = "Please correct this field.";
            }
          } else if (field instanceof HTMLTextAreaElement) {
            errorDiv.textContent = field.required ? "This field is required." : "Please correct this field.";
          } else if (field instanceof HTMLSelectElement) {
            errorDiv.textContent = field.required ? "Please select an option." : "Please correct this field.";
          } else {
            errorDiv.textContent = "Please correct this field.";
          }
          p.appendChild(errorDiv);
        }
      }
    };
    const clearFieldState = (field) => {
      field.classList.remove("is-valid", "is-error");
      field.removeAttribute("aria-invalid");
      const p = field.parentElement;
      if (p) {
        p.classList.remove("is-valid", "is-error");
        p.querySelectorAll(".o-form__error").forEach((el) => el.remove());
      }
    };
    const cssEscape = (val) => {
      var _a;
      return ((_a = window.CSS) == null ? void 0 : _a.escape) ? window.CSS.escape(val) : val.replace(/[^a-zA-Z0-9_-]/g, "\\$&");
    };
    const getRadioGroup = (field) => {
      if (field.type !== "radio" || !field.name) return null;
      const form = closestForm(field) || document;
      const name = cssEscape(field.name);
      return Array.from(form.querySelectorAll(`input[type="radio"][name="${name}"]`));
    };
    const validateFileAccept = (file, accept) => {
      if (!accept) return true;
      const parts = accept.split(",").map((s) => s.trim()).filter(Boolean);
      if (!parts.length) return true;
      const { type, name } = file;
      const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
      for (const ruleRaw of parts) {
        const rule = ruleRaw.toLowerCase();
        if (rule.endsWith("/*")) {
          const prefix = rule.slice(0, -1);
          if (type.toLowerCase().startsWith(prefix)) return true;
        } else if (rule.startsWith(".")) {
          if (ext && `.${ext}` === rule) return true;
        } else {
          if (type.toLowerCase() === rule) return true;
        }
      }
      return false;
    };
    const validateFileInput = (field) => {
      const files = field.files;
      if (field.required && (!files || files.length === 0)) return false;
      const accept = field.getAttribute("accept") || "";
      if (files && files.length && accept) {
        for (const f of Array.from(files)) {
          if (!validateFileAccept(f, accept)) return false;
        }
      }
      return true;
    };
    const validateRadioGroup = (field) => {
      const group = getRadioGroup(field);
      if (!group) return field.checkValidity();
      const required = group.some((r) => r.required);
      if (!required) return true;
      return group.some((r) => r.checked);
    };
    const validateCheckbox = (field) => field.required ? field.checked === true : true;
    const validateField = (field) => {
      if (field.disabled) return true;
      if (field.type === "radio") {
        const radio = field;
        const valid2 = validateRadioGroup(radio);
        const group = getRadioGroup(radio) || [radio];
        group.forEach((r) => setFieldState(r, valid2));
        return valid2;
      }
      if (field.type === "checkbox") {
        const checkbox = field;
        const valid2 = validateCheckbox(checkbox);
        setFieldState(checkbox, valid2);
        return valid2;
      }
      if (field.type === "file") {
        const fileInput = field;
        const valid2 = validateFileInput(fileInput) && fileInput.checkValidity();
        setFieldState(fileInput, valid2);
        return valid2;
      }
      const valid = field.checkValidity();
      setFieldState(field, valid);
      return valid;
    };
    const validateAllInForm = (form) => {
      const fields = Array.from(form.elements).filter(isSubmittable);
      let allValid = true;
      for (const f of fields) {
        if (f.type === "radio") {
          const group = getRadioGroup(f);
          if (!group || group[0] !== f) continue;
          const valid = validateRadioGroup(f);
          group.forEach((r) => setFieldState(r, valid));
          allValid && (allValid = valid);
        } else {
          const valid = validateField(f);
          allValid && (allValid = valid);
        }
      }
      return allValid;
    };
    const announce = (form, msg) => {
      let region = form.__liveRegion;
      if (!region) {
        region = document.createElement("div");
        region.setAttribute("aria-live", "polite");
        region.setAttribute("aria-atomic", "true");
        region.className = "visually-hidden";
        form.appendChild(region);
        form.__liveRegion = region;
      }
      region.textContent = msg;
    };
    const onTouch = (e) => {
      const target = e.target;
      if (!isSubmittable(target)) return;
      if (!touched.has(target)) touched.add(target);
      validateField(target);
    };
    const onSubmit = (e) => {
      var _a;
      const form = e.target;
      if (!form.hasAttribute("novalidate")) {
        form.setAttribute("novalidate", "true");
      }
      const valid = validateAllInForm(form);
      if (!valid) {
        e.preventDefault();
        e.stopPropagation();
        const firstInvalid = form.querySelector("input.is-error, textarea.is-error, select.is-error");
        (_a = firstInvalid == null ? void 0 : firstInvalid.focus) == null ? void 0 : _a.call(firstInvalid, { preventScroll: false });
        announce(form, "Please correct the highlighted fields.");
      }
    };
    const onSubmitButtonClick = (e) => {
      var _a;
      const target = e.target;
      const btn = (_a = target == null ? void 0 : target.closest) == null ? void 0 : _a.call(target, 'button, input[type="submit"]');
      if (!btn) return;
      if (btn.type !== "submit") return;
      const form = btn.form || btn.closest("form");
      if (!form) return;
      validateAllInForm(form);
    };
    const attachForm = (form) => {
      if (form.__validationWired) return;
      form.__validationWired = true;
      form.addEventListener("invalid", function(event) {
        event.preventDefault();
      }, true);
      form.addEventListener("submit", onSubmit);
      const fields = Array.from(form.elements).filter(isSubmittable);
      for (const f of fields) {
        TOUCH_EVENTS.forEach((evt) => f.addEventListener(evt, onTouch));
      }
      form.addEventListener("click", onSubmitButtonClick, true);
      const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
          m.addedNodes.forEach((node) => {
            var _a;
            if (!(node instanceof Element)) return;
            if (isSubmittable(node)) {
              TOUCH_EVENTS.forEach((evt) => node.addEventListener(evt, onTouch));
              clearFieldState(node);
            }
            (_a = node.querySelectorAll) == null ? void 0 : _a.call(node, "input, select, textarea").forEach((el) => {
              if (isSubmittable(el)) {
                TOUCH_EVENTS.forEach((evt) => el.addEventListener(evt, onTouch));
                clearFieldState(el);
              }
            });
          });
        }
      });
      mo.observe(form, { childList: true, subtree: true });
      form.__validationObserver = mo;
    };
    const scanAndAttach = () => {
      document.querySelectorAll("form").forEach(attachForm);
    };
    window.FormValidator = {
      rescan: scanAndAttach,
      validateForm: validateAllInForm,
      validateField
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", scanAndAttach, { once: true });
    } else {
      scanAndAttach();
    }
    document.addEventListener("blur", onTouch, true);
  })();

  // scripts/tools/event.ts
  var delegate = (params) => {
    const { element, selector, event, callback, events } = params;
    const internalCallback = (event2) => {
      let target = findTarget(event2, selector);
      if (!target) return;
      callback(event2, target);
    };
    let elem = typeof element === "string" ? document.querySelector(element) : element.documentElement ? element.documentElement : element;
    if (!elem) return null;
    const arrEvents = [];
    if (event) arrEvents.push(event);
    if (events) arrEvents.push(...events);
    arrEvents.map((evt) => elem.addEventListener(evt, internalCallback));
    return () => {
      arrEvents.forEach((evt) => {
        elem && elem.removeEventListener(evt, internalCallback);
      });
    };
  };
  var findTarget = (e, selector) => {
    if (!e.target || !(e.target instanceof HTMLElement || e.target instanceof SVGElement) || typeof e.target["matches"] === "undefined") return;
    const target = e.target.matches(selector) ? e.target : e.target.closest(selector);
    return target;
  };

  // scripts/objects/light-box.ts
  var CLASS_OPEN = "is-light-box-open";
  var SEL_TRIGGER = "[data-light-box-trigger]";
  var ATTR_TRIGGER = "data-light-box-trigger";
  var tmpl = document.createElement("template");
  var closeIcon = `<svg class="close-icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m19.28 5.78.53-.53-1.06-1.06-.53.53 1.06 1.06ZM4.72 18.22l-.53.53 1.06 1.06.53-.53-1.06-1.06Zm13.5-13.5-13.5 13.5 1.06 1.06 13.5-13.5-1.06-1.06Z" fill="#000"/><path d="m18.22 19.28.53.53 1.06-1.06-.53-.53-1.06 1.06ZM5.78 4.72l-.53-.53-1.06 1.06.53.53 1.06-1.06Zm13.5 13.5L5.78 4.72 4.72 5.78l13.5 13.5 1.06-1.06Z" fill="#000"/></svg>`;
  tmpl.innerHTML = `
  <style>
    * { box-sizing: border-box; }

    .container {
      display: none;
      justify-content: stretch;
      align-items: stretch;
    }

    .close-icon {
      cursor: pointer;
      width: 1.25rem;
      position: absolute;
      right: 2%;
      top: 1%;
    }

    .background {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: all ${ANIMATION_SETTINGS.timeDefault} ${ANIMATION_SETTINGS.easeOut};
    }

    .wrapper {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      overflow-y: auto;
    }

    .inner {
      padding: 1rem;
      width: 100%;
      min-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .popup {
      box-sizing: border-box;
      position: relative;
      width: 100%;
      max-width: 87.5rem;
      padding: 2rem 1rem;

      opacity: 0;
      transform: translateY(-2rem);
      transition: all ${ANIMATION_SETTINGS.timeDefault} ${ANIMATION_SETTINGS.easeOut};
    }

    .popup.small { max-width: 30rem; }
    .popup.large { max-width: 80rem; }
    .container.is-visible { display: block; }

    .is-closing .popup { transform: translateY(2rem); }
    .is-open .background { opacity: 1; }
    .is-open .popup {
      opacity: 1;
      transform: translateY(0);
    }
  </style>

  <div part="root" class="container">
    <div part="background" class="background"></div>
    <div part="wrapper" class="wrapper">
      <div part="inner" class="inner">
        <div part="popup" class="popup">
        ${closeIcon}
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
`;
  var LightBoxElement = class _LightBoxElement extends HTMLElement {
    constructor() {
      super();
      __publicField(this, "confirm", (params) => {
        const lb = new _LightBoxElement();
        document.body.appendChild(lb);
        lb.classList.add("o-light-box__confirm");
        lb.size = "small";
        const buttons = document.createElement("div");
        buttons.classList.add("o-light-box__buttons");
        const btnYes = document.createElement("button");
        btnYes.type = "button";
        btnYes.classList.add("o-btn");
        btnYes.textContent = params.yes;
        const btnNo = document.createElement("button");
        btnNo.type = "button";
        btnNo.classList.add("o-btn");
        btnNo.textContent = params.no;
        const title = document.createElement("h2");
        title.textContent = params.title;
        lb.appendChild(title);
        lb.appendChild(buttons);
        buttons.appendChild(btnYes);
        buttons.appendChild(btnNo);
        lb.visible = true;
        const decided = () => {
          btnYes.disabled = true;
          btnYes.classList.add("is-disabled");
          btnNo.disabled = true;
          btnNo.classList.add("is-disabled");
          lb.visible = false;
          setTimeout(() => lb.remove(), ANIMATION_SETTINGS.durationDefault);
        };
        return new Promise((resolve, reject) => {
          btnYes.addEventListener("click", () => {
            resolve(true);
            decided();
          });
          btnNo.addEventListener("click", () => {
            resolve(false);
            decided();
          });
        });
      });
      // Properties
      __publicField(this, "root");
      __publicField(this, "inner");
      __publicField(this, "popup");
      __publicField(this, "parent");
      __publicField(this, "close");
      __publicField(this, "timeout");
      // Events
      __publicField(this, "onKeyPress", (e) => {
        if (this.closable && e.key == "Escape") {
          this.visible = false;
        }
      });
      __publicField(this, "onBackgroundClick", (e) => {
        if (e.target !== this.inner) return;
        if (this.closable) this.visible = false;
      });
      __publicField(this, "onDocumentClick", (e, target) => {
        const attr = target.getAttribute(ATTR_TRIGGER);
        if (!attr) return;
        if (!this.matches(attr)) return;
        e.preventDefault();
        this.visible = this.closable ? !this.visible : true;
      });
      this.timeout = null;
      const sr = this.attachShadow({ mode: "open" });
      sr.appendChild(tmpl.content.cloneNode(true));
      this.root = sr.querySelector(".container");
      this.inner = sr.querySelector(".inner");
      this.popup = sr.querySelector(".popup");
      this.parent = this.parentElement || null;
      this.close = sr.querySelector(".close-icon");
      this.close.addEventListener("click", () => {
        this.visible = false;
      });
      document.addEventListener("keydown", this.onKeyPress);
      delegate({
        callback: this.onDocumentClick,
        selector: SEL_TRIGGER,
        element: document,
        event: "click"
      });
      this.inner.addEventListener("click", this.onBackgroundClick);
      this.updateVisible();
    }
    static get observedAttributes() {
      return ["visible", "closable", "size"];
    }
    // Getters and setters
    get visible() {
      return this.getAttribute("visible") == "true" ? true : false;
    }
    set visible(value) {
      this.setAttribute("visible", value + "");
      this.updateVisible();
    }
    get closable() {
      return this.hasAttribute("closable") ? this.getAttribute("closable") == "true" : true;
    }
    set closable(value) {
      this.setAttribute("closable", value + "");
    }
    get size() {
      return this.getAttribute("size") || "medium";
    }
    set size(value) {
      this.setAttribute("size", value);
      this.updateSize();
    }
    get padded() {
      return this.hasAttribute("padded") ? this.getAttribute("padded") == "true" : true;
    }
    set padded(value) {
      this.setAttribute("padded", value + "");
      this.updatePadded();
    }
    updateVisible() {
      if (this.timeout) clearTimeout(this.timeout);
      if (this.visible) {
        document.body.classList.add(CLASS_OPEN);
        this.root.classList.add("is-visible");
        this.root.classList.remove("is-closing");
        document.body.appendChild(this);
        this.timeout = setTimeout(() => this.root.classList.add("is-open"), 16);
        this.root.part.add("visible");
      } else {
        document.body.classList.remove(CLASS_OPEN);
        (this.parent || document.body).appendChild(this);
        setTimeout(() => {
          this.root.classList.remove("is-open");
          this.root.classList.add("is-closing");
        }, 16);
        this.timeout = setTimeout(() => {
          this.root.classList.remove("is-visible");
          this.root.classList.remove("is-closing");
        }, ANIMATION_SETTINGS.durationDefault);
        this.root.part.remove("visible");
      }
    }
    updateSize() {
      this.popup.classList.remove("small");
      this.popup.classList.remove("large");
      switch (this.size) {
        case "small":
          this.popup.classList.add("small");
          break;
        case "large":
          this.popup.classList.add("large");
          break;
        case "medium":
          break;
      }
    }
    updatePadded() {
      if (this.padded) {
        this.popup.part.remove("unpadded");
      } else {
        this.popup.part.add("unpadded");
      }
    }
    attributeChangedCallback(attr, oldValue, newValue) {
      switch (attr) {
        case "visible":
          this.updateVisible();
          break;
        case "size":
          this.updateSize();
          break;
        case "padded":
          this.updatePadded();
          break;
      }
    }
  };
  if (!customElements.get("light-box")) {
    customElements.define("light-box", LightBoxElement);
  }

  // scripts/tools/classes.ts
  var CLASS_ACTIVE = "is-active";
  var CLASS_OPEN2 = "is-open";
  var CLASS_SCROLL_DISABLED = "is-scroll-disabled";
  var CLASS_DRAWER_OPEN = "is-drawer-open";
  var CLASS_MENU_HOVER = "is-menu-hover";
  var CLASS_SEARCH_OPEN = "is-search-open";

  // scripts/objects/slide-drawer.ts
  var ATTR_DRAWER = "data-slide-drawer";
  var ATTR_TOGGLE = "data-slide-drawer-toggle";
  var ATTR_CLOSE = "data-drawer-close";
  var SlideDrawer = class _SlideDrawer {
    constructor(drawerElement) {
      __publicField(this, "drawerElement");
      __publicField(this, "id");
      __publicField(this, "toggleElements", []);
      __publicField(this, "closeElements", []);
      __publicField(this, "isOpen", false);
      __publicField(this, "handleKeydownBound", (e) => this.handleKeydown(e));
      __publicField(this, "lastFocused", null);
      __publicField(this, "toggleDrawer", (e) => {
        e == null ? void 0 : e.preventDefault();
        if ((e == null ? void 0 : e.currentTarget) && e.currentTarget instanceof HTMLElement) {
          if (!this.isOpen) {
            e.currentTarget.classList.add(CLASS_ACTIVE);
          }
        }
        this.isOpen ? this.closeDrawer() : this.openDrawer();
      });
      __publicField(this, "openDrawer", () => {
        if (this.isOpen) return;
        this.isOpen = true;
        this.lastFocused = document.activeElement || null;
        document.body.classList.add(CLASS_DRAWER_OPEN, CLASS_SCROLL_DISABLED);
        this.drawerElement.classList.add(CLASS_OPEN2);
        this.drawerElement.setAttribute("aria-hidden", "false");
        const focusTarget = this.drawerElement.querySelector('[autofocus], button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        focusTarget == null ? void 0 : focusTarget.focus();
        document.addEventListener("keydown", this.handleKeydownBound);
      });
      __publicField(this, "closeDrawer", (e) => {
        var _a, _b;
        e == null ? void 0 : e.preventDefault();
        if (!this.isOpen) return;
        this.isOpen = false;
        document.body.classList.remove(CLASS_DRAWER_OPEN, CLASS_SCROLL_DISABLED);
        this.drawerElement.classList.remove(CLASS_OPEN2);
        this.drawerElement.setAttribute("aria-hidden", "true");
        this.toggleElements.forEach((el) => el.classList.remove(CLASS_ACTIVE));
        document.removeEventListener("keydown", this.handleKeydownBound);
        (_b = (_a = this.lastFocused) == null ? void 0 : _a.focus) == null ? void 0 : _b.call(_a);
        this.lastFocused = null;
      });
      this.drawerElement = drawerElement;
      const id = drawerElement.getAttribute(ATTR_DRAWER);
      if (!id) throw new Error(`SlideDrawer: drawer missing ${ATTR_DRAWER} id.`);
      this.id = id;
      this.queryChildren();
      this.attachEvents();
      this.drawerElement.setAttribute("aria-hidden", this.isOpen ? "false" : "true");
    }
    // Find only the toggles that target THIS drawer id + close buttons inside this drawer
    queryChildren() {
      this.toggleElements = Array.from(
        document.querySelectorAll(`[${ATTR_TOGGLE}="${this.id}"]`)
      );
      this.closeElements = Array.from(
        this.drawerElement.querySelectorAll(`[${ATTR_CLOSE}]`)
      );
    }
    attachEvents() {
      this.toggleElements.forEach((el) => el.addEventListener("click", this.toggleDrawer));
      this.closeElements.forEach((el) => el.addEventListener("click", this.closeDrawer));
    }
    handleKeydown(e) {
      if (e.key === "Escape") this.closeDrawer();
    }
    // Helper to initialize all drawers on the page
    static initAll() {
      const drawers = Array.from(document.querySelectorAll(`[${ATTR_DRAWER}]`));
      return drawers.map((el) => new _SlideDrawer(el));
    }
  };
  SlideDrawer.initAll();

  // scripts/shopify/tools.ts
  var ON_CART_FINISHED = "cart:finished";
  var CART_EVENTS = {
    UPDATED: "cart:updated",
    ITEM_ADDED: "cart:itemAdded",
    ITEM_REMOVED: "cart:itemRemoved"
  };
  var dispatchCartEvent = (name, detail) => {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  };
  var headers = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  var cartGetCurrent = async () => {
    const res = await fetch("/cart.js", { method: "GET", headers });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  };
  var cartChange = async ({
    quantity,
    id
  }) => {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers,
      body: JSON.stringify({ id, quantity })
    });
    if (!res.ok) throw new Error("Failed to change item quantity");
    const cart = await res.json();
    if (quantity === 0) {
      dispatchCartEvent(CART_EVENTS.ITEM_REMOVED, { id });
    }
    dispatchCartEvent(CART_EVENTS.UPDATED, { action: "change", id, quantity });
    dispatchCartEvent(ON_CART_FINISHED, { action: "change" });
    return cart;
  };

  // scripts/objects/quantity-selector.ts
  var tmpl2 = document.createElement("template");
  tmpl2.innerHTML = `
  <slot></slot>
`;
  var EVT_QTY_CHANGED = "onQtyChange";
  var EventQtyChanged = class extends CustomEvent {
  };
  var QuantitySelectorElement = class extends HTMLElement {
    constructor() {
      var _a, _b, _c;
      super();
      // Properties
      __publicField(this, "input", null);
      __publicField(this, "btnMinus", null);
      __publicField(this, "btnPlus", null);
      __publicField(this, "line", null);
      __publicField(this, "fallbackValue", 0);
      __publicField(this, "fallbackMin", null);
      __publicField(this, "fallbackMax", null);
      __publicField(this, "onPlusClick", (e) => {
        e.preventDefault();
        this.value += 1;
        this.onQuantityChanged();
      });
      __publicField(this, "onMinusClick", (e) => {
        e.preventDefault();
        this.value -= 1;
        this.onQuantityChanged();
      });
      __publicField(this, "onInputChanged", (e) => {
        var _a;
        this.value = ((_a = this.input) == null ? void 0 : _a.valueAsNumber) || this.value;
        this.onQuantityChanged();
      });
      const sr = this.attachShadow({ mode: "open" });
      sr.appendChild(tmpl2.content.cloneNode(true));
      this.btnMinus = this.querySelector(".is-minus");
      this.btnPlus = this.querySelector(".is-plus");
      this.input = this.querySelector('input[type="number"]');
      this.classList.add("o-quantity-selector");
      this.line = this.getAttribute("line");
      (_a = this.btnMinus) == null ? void 0 : _a.addEventListener("click", this.onMinusClick);
      (_b = this.btnPlus) == null ? void 0 : _b.addEventListener("click", this.onPlusClick);
      (_c = this.input) == null ? void 0 : _c.addEventListener("change", this.onInputChanged);
      this.updateDisabled();
    }
    // Getters/Setters
    get value() {
      return this.input ? this.input.valueAsNumber : this.fallbackValue;
    }
    set value(value) {
      if (this.max !== null) value = Math.min(this.max, value);
      if (this.min !== null) value = Math.max(this.min, value);
      if (this.input) this.input.valueAsNumber = value;
      this.fallbackValue = value;
    }
    get min() {
      const strMin = this.input ? this.input.min : this.fallbackMin;
      if (strMin === null) return null;
      if (typeof strMin === "string") {
        const iMin = parseInt(strMin);
        if (!strMin.replace(/\s/g, "").length) return null;
        if (isNaN(iMin)) return null;
      }
      return strMin;
    }
    set min(value) {
      if (value === null) {
        if (this.input) this.input.min = "";
        this.fallbackMin = null;
      } else {
        if (this.input) this.input.min = value.toString();
        this.fallbackMin = this.fallbackMin;
      }
    }
    get max() {
      const strMax = this.input ? this.input.max : this.fallbackMax;
      if (strMax === null) return null;
      if (typeof strMax === "string") {
        const iMax = parseInt(strMax);
        if (!strMax.replace(/\s/g, "").length) return null;
        if (isNaN(iMax)) return null;
      }
      return strMax;
    }
    set max(value) {
      if (value === null) {
        if (this.input) this.input.max = "";
        this.fallbackMax = null;
      } else {
        if (this.input) this.input.max = value.toString();
        this.fallbackMax = value;
        if (this.value > value) {
          this.value = value;
        }
      }
    }
    get disabled() {
      return this.hasAttribute("disabled");
    }
    set disabled(disabled) {
      if (disabled) {
        this.setAttribute("disabled", "disabled");
      } else {
        this.removeAttribute("disabled");
      }
      this.updateDisabled();
    }
    onQuantityChanged() {
      if (this.line) {
        try {
          cartChange({ quantity: this.value, id: Number(this.line) });
        } catch (e) {
          console.warn(e);
        }
      }
      const evt = new EventQtyChanged(EVT_QTY_CHANGED, {
        bubbles: true,
        cancelable: false,
        detail: {
          qtySelector: this,
          newValue: this.value
        }
      });
      this.dispatchEvent(evt);
    }
    updateDisabled() {
      const de = (n) => {
        if (!n) return;
        n.disabled = true;
        n.classList.add("is-disabled");
      };
      const ee = (n) => {
        if (!n) return;
        n.disabled = false;
        n.classList.remove("is-disabled");
      };
      [
        this.btnMinus,
        this.btnPlus,
        this.input
      ].forEach((e) => {
        this.disabled ? de(e) : ee(e);
      });
      if (this.disabled) {
        this.classList.add("is-disabled");
      } else {
        this.classList.remove("is-disabled");
      }
    }
  };
  if (!customElements.get("quantity-selector")) {
    customElements.define("quantity-selector", QuantitySelectorElement);
  }

  // scripts/tools/section.ts
  var ATTR_SECTION_INITIALIZED = "data-section-initialized";
  var _Section = class _Section {
    constructor(element, selector) {
      // Class itself.
      __publicField(this, "selector");
      __publicField(this, "container");
      __publicField(this, "shopifyContainer");
      __publicField(this, "id");
      __publicField(this, "innerHtmlObserver");
      __publicField(this, "onInnerHtmlMutationObserved", (mutations, observer) => {
        if (!mutations.length) return;
        if (!this.shopifyContainer) return;
        const [mutation] = mutations;
        const removedNodes = [];
        mutation.removedNodes.forEach((n) => removedNodes.push(n));
        const index = removedNodes.findIndex((rn) => rn === this.shopifyContainer);
        if (index === -1) return;
        console.log("Section", this.id, "reloaded.");
        this.dispose();
        _Section.recheck(this.selector);
      });
      this.container = element;
      this.selector = selector;
      this.container.setAttribute(ATTR_SECTION_INITIALIZED, "true");
      this.shopifyContainer = this.container.parentElement;
      if (this.shopifyContainer && this.shopifyContainer.id) {
        try {
          this.id = this.shopifyContainer.id.replace(/shopify-section-/, "");
        } catch (e) {
          console.warn(e);
        }
      }
    }
    /**
     * Register a given section handler for a section selector.
     * 
     * @param selector Selector used to query on the section(s).
     * @param t The handling class for that section.
     * @returns The list of currently registered sections.
     */
    static register(selector, t) {
      const sections = [];
      document.querySelectorAll(selector).forEach((element) => {
        if (_Section.isRegistered(element)) return;
        const sect = new t(element, selector);
        sections.push(sect);
        sect.queryChildren(element);
        sect.init();
        sect.attachEvents(element);
      });
      this.registrations[selector] = t;
      return sections;
    }
    static recheck(selector) {
      const t = this.registrations[selector];
      if (!t) return [];
      return _Section.register(selector, t);
    }
    /**
     * Checks if the given section has been registered or not.
     * 
     * @param element Element to check if has been registered.
     * @returns True if registered, otherwise false.
     */
    static isRegistered(element) {
      return element.hasAttribute(ATTR_SECTION_INITIALIZED);
    }
    replaceContainer(newContainer) {
      this.container.removeAttribute(ATTR_SECTION_INITIALIZED);
      this.detatchEvents(this.container);
      this.container.innerHTML = newContainer.innerHTML;
      this.container.setAttribute(ATTR_SECTION_INITIALIZED, "true");
      this.queryChildren(this.container);
      this.init();
      this.attachEvents(this.container);
    }
    init() {
    }
    dispose() {
      this.container.removeAttribute(ATTR_SECTION_INITIALIZED);
      this.detatchEvents(this.container);
      if (this.innerHtmlObserver) this.innerHtmlObserver.disconnect();
    }
  };
  __publicField(_Section, "registrations", {});
  var Section = _Section;

  // scripts/settings/responsive.ts
  var RESPONSIVE_SIZES = {
    xxsmall: 375,
    xsmall: 480,
    small: 750,
    medium: 1100,
    large: 1350,
    xlarge: 1650,
    xxlarge: 2e3
  };
  var RESPONSIVE_DEFINITIONS = Object.fromEntries(
    Object.entries(RESPONSIVE_SIZES).map(([k, v]) => [k, `${v}px`])
  );
  var responsiveMediaAbove = (definition) => {
    if (typeof window === "undefined") return false;
    return window.innerWidth >= RESPONSIVE_SIZES[definition];
  };

  // scripts/tools/document.ts
  var documentDisableScroll = () => {
    document.documentElement.classList.add(CLASS_SCROLL_DISABLED);
  };
  var documentEnableScroll = () => {
    document.documentElement.classList.remove(CLASS_SCROLL_DISABLED);
  };

  // scripts/components/navigation/menu.ts
  var SELECTOR_MENU = "[data-main-menu]";
  var SELECTOR_SUBMENU = "[data-menu-submenu]";
  var SELECTOR_MENU_TOGGLE = "[data-menu-toggle]";
  var SELECTOR_MENU_CLOSE = "[data-menu-close]";
  var SELECTOR_SUBMENU_TOGGLE = "[data-submenu-toggle]";
  var SELECTOR_MENU_BACK = "[data-submenu-back]";
  var ATTR_SUBMENU = "data-menu-submenu";
  var CLASS_MENU_OPEN = "is-menu-open";
  var CLASS_SUBMENU_OPEN = "is-submenu-open";
  var CLASS_MENU_LEVEL = "is-menu-level-";
  var Menu = class {
    constructor(container, header) {
      __publicField(this, "container");
      __publicField(this, "header");
      __publicField(this, "submenus", null);
      __publicField(this, "menuLevel", 1);
      __publicField(this, "currentMenu", null);
      /*
        Events
      */
      __publicField(this, "onMenuToggle", (e) => {
        a;
        e.preventDefault();
        if (responsiveMediaAbove("medium")) {
          this.container.classList.remove(CLASS_MENU_OPEN);
          this.header.classList.remove(CLASS_MENU_HOVER, CLASS_SEARCH_OPEN);
        } else {
          if (this.container.classList.contains(CLASS_MENU_OPEN)) return this.closeMenu();
          this.openMenu();
        }
      });
      __publicField(this, "onSubmenuOpen", (e) => {
        var _a;
        e.preventDefault();
        const thisTarget = e.currentTarget;
        const newSubmenu = (_a = thisTarget == null ? void 0 : thisTarget.parentElement) == null ? void 0 : _a.querySelector(SELECTOR_SUBMENU);
        if (!newSubmenu || !newSubmenu.getAttribute(ATTR_SUBMENU)) {
          return console.warn("Error: Menu structure has changed.");
        }
        this.updateSubmenuClasses(null, newSubmenu);
        documentDisableScroll();
      });
      __publicField(this, "onSubmenuBack", (e) => {
        var _a;
        e.preventDefault();
        const parentElement = (_a = this.currentMenu) == null ? void 0 : _a.closest("li");
        const newSubmenu = parentElement == null ? void 0 : parentElement.closest(SELECTOR_SUBMENU);
        if (!newSubmenu) return console.warn("Error: Menu structure has changed.");
        this.updateSubmenuClasses(this.currentMenu, newSubmenu);
      });
      // onMouseOver = () => {
      //   if(!this.header.classList.contains(CLASS_MENU_HOVER)) {
      //     this.header.classList.add(CLASS_MENU_HOVER);
      //   }
      // }
      // onMouseOut = () => {
      //   this.header.classList.remove(CLASS_MENU_HOVER);
      // }
      /*
        Methods
      */
      //Closing all submenus and hiding the drawer
      __publicField(this, "closeMenu", () => {
        var _a;
        this.container.classList.remove(CLASS_MENU_OPEN);
        this.header.classList.remove(CLASS_MENU_OPEN, CLASS_MENU_HOVER);
        (_a = this.container.querySelector(SELECTOR_SUBMENU)) == null ? void 0 : _a.classList.add(CLASS_SUBMENU_OPEN);
        this.resetSubmenuClasses();
        this.updateMenuStateClasses(1);
        documentEnableScroll();
      });
      __publicField(this, "openMenu", () => {
        this.container.classList.add(CLASS_MENU_OPEN);
        this.header.classList.add(CLASS_MENU_OPEN);
        documentDisableScroll();
      });
      __publicField(this, "resetSubmenuClasses", () => {
        this.container.querySelectorAll(SELECTOR_SUBMENU).forEach((submenu) => {
          submenu.classList.remove(CLASS_SUBMENU_OPEN);
        });
      });
      __publicField(this, "updateSubmenuClasses", (thisSubmenu, newSubmenu) => {
        const newLevel = parseInt(newSubmenu.getAttribute(ATTR_SUBMENU) || "");
        if (!newLevel || !this.submenus) return;
        thisSubmenu == null ? void 0 : thisSubmenu.classList.remove(CLASS_SUBMENU_OPEN);
        Array.from(this.submenus).forEach((menu) => {
          const equalNode = menu.isEqualNode(newSubmenu);
          const innerMenuLevel = parseInt(menu.getAttribute(ATTR_SUBMENU) || "");
          if (this.menuLevel === 3 && innerMenuLevel === 3 && !equalNode) {
            menu.classList.remove(CLASS_SUBMENU_OPEN);
          } else if (equalNode) {
            menu.classList.add(CLASS_SUBMENU_OPEN);
          }
        });
        this.currentMenu = newSubmenu;
        this.updateMenuStateClasses(newLevel);
      });
      __publicField(this, "updateMenuStateClasses", (newLevel) => {
        this.container.classList.remove(`${CLASS_MENU_LEVEL}${this.menuLevel}`);
        this.container.classList.add(`${CLASS_MENU_LEVEL}${newLevel}`);
        this.menuLevel = newLevel;
        if (responsiveMediaAbove("medium") && this.header) {
          if (!this.header.classList.contains(CLASS_MENU_OPEN) && newLevel > 1) {
            this.header.classList.add(CLASS_MENU_OPEN);
          } else if (newLevel == 1) {
            this.header.classList.remove(CLASS_MENU_OPEN);
          }
        }
      });
      this.container = container;
      this.header = header;
      this.queryChildren(container);
      this.attachEvents();
    }
    queryChildren(container) {
      this.submenus = container.querySelectorAll(SELECTOR_SUBMENU);
    }
    attachEvents() {
      document.querySelectorAll(SELECTOR_MENU_TOGGLE).forEach((element) => {
        element.addEventListener("click", this.onMenuToggle);
      });
      document.querySelectorAll(SELECTOR_MENU_CLOSE).forEach((element) => {
        element.addEventListener("click", this.closeMenu);
      });
      this.container.querySelectorAll(SELECTOR_SUBMENU_TOGGLE).forEach((element) => {
        element.addEventListener("click", this.onSubmenuOpen);
      });
      this.container.querySelectorAll(SELECTOR_MENU_BACK).forEach((element) => {
        element.addEventListener("click", this.onSubmenuBack);
      });
    }
  };

  // scripts/components/navigation/header.ts
  var SELECTOR_CONTAINER = "[data-header]";
  var SELECTOR_CART_COUNT = "[data-cart-counter]";
  var Header = class extends Section {
    constructor() {
      super(...arguments);
      __publicField(this, "cartCountElement", null);
      __publicField(this, "menuElement", null);
      __publicField(this, "lastScrollY", window.scrollY);
      __publicField(this, "ticking", false);
      __publicField(this, "footer", null);
      __publicField(this, "onCartUpdate", () => {
        if (!this.cartCountElement) return;
        const count = cartGetCurrent()["item_count"] || 0;
        this.cartCountElement.innerText = count.toString();
        if (count > 0) {
          this.cartCountElement.classList.add("is-visible");
        } else {
          this.cartCountElement.classList.remove("is-visible");
        }
      });
      __publicField(this, "handleScroll", () => {
        const currentScrollY = window.scrollY;
        if (currentScrollY === 0) {
          document.body.classList.remove("is-scrolling--down", "is-scrolling--up");
        } else if (currentScrollY > this.lastScrollY) {
          document.body.classList.add("is-scrolling--down");
          document.body.classList.remove("is-scrolling--up");
        } else if (currentScrollY < this.lastScrollY) {
          document.body.classList.add("is-scrolling--up");
          document.body.classList.remove("is-scrolling--down");
        }
        this.lastScrollY = currentScrollY;
        if (this.footer) {
          const footerRect = this.footer.getBoundingClientRect();
          const inView = footerRect.top < window.innerHeight && footerRect.bottom > 0;
          document.body.classList.toggle("is-footer-visible", inView);
        }
        this.ticking = false;
      });
      __publicField(this, "onScroll", () => {
        if (!this.ticking) {
          window.requestAnimationFrame(this.handleScroll);
          this.ticking = true;
        }
      });
    }
    queryChildren(container) {
      this.cartCountElement = container.querySelector(SELECTOR_CART_COUNT);
      this.menuElement = container.querySelector(SELECTOR_MENU);
      this.footer = document.querySelector("footer");
    }
    attachEvents() {
      window.addEventListener(CART_EVENTS.UPDATED, this.onCartUpdate);
      if (this.menuElement) new Menu(this.menuElement, this.container);
      window.addEventListener("scroll", this.onScroll);
    }
    detatchEvents() {
      window.removeEventListener(CART_EVENTS.UPDATED, this.onCartUpdate);
      window.removeEventListener("scroll", this.onScroll);
    }
  };
  Section.register(SELECTOR_CONTAINER, Header);

  // scripts/layouts/theme.ts
  document.documentElement.classList.remove("js-unavailable");
  document.documentElement.classList.add("js-available");
})();
